import React, { Component, Fragment } from "react"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import PropTypes from "prop-types"
import LocationsEmployeeSelectionModal from "./Modals/LocationsEmployeeSelectionModal"
import * as reportSelectionActions from "../../state/actions/reportSelectionActions"

class LocationSelection extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    setLocationsAndEmployees: PropTypes.func.isRequired,
    reportSelection: PropTypes.shape({
      selectedLocations: PropTypes.arrayOf(PropTypes.number),
      selectedEmployees: PropTypes.arrayOf(PropTypes.shape({
        employeeId: PropTypes.number,
        includeDirectReports: PropTypes.bool,
      })),
    }).isRequired,
  }

  state = {
    showModal: false,
  }

  render() {
    const { t, reportSelection, setLocationsAndEmployees } = this.props

    const editClicked = () => {
      this.setState({ showModal: true })
    }
    const closePopup = () => {
      this.setState({ showModal: false })
    }

    const updateSelections = (employees, locations) => {
      setLocationsAndEmployees(locations, employees)
    }

    return (
      <Fragment>
        <div className="row form-group">
          <div className="col-lg-5 col-md-5">
            {t("CustomReport.LocationsEmployeeSelection.SelectText")} *
          </div>
          <div className="col-lg-4 col-md-4" style={{ color: "#999" }}>
            {reportSelection.selectedLocations && reportSelection.selectedLocations.length > 0
              ? `${reportSelection.selectedLocations.length} ${
                  reportSelection.selectedLocations.length === 1
                    ? t("CustomReport.Common.Location")
                    : t("CustomReport.Common.Locations")
                }`
              : null}
            {(!reportSelection.selectedLocations ||
              reportSelection.selectedLocations.length === 0) &&
            reportSelection.selectedEmployees.length === 0
              ? t("CustomReport.Common.NoLocations")
              : null}
            {reportSelection.selectedLocations &&
            reportSelection.selectedLocations.length > 0 &&
            reportSelection.selectedEmployees.length > 0
              ? ` ${t("CustomReport.Common.LocationsEmployeesConjunction")} `
              : null}
            {reportSelection.selectedEmployees.length > 0
              ? `${reportSelection.selectedEmployees.length} ${
                  reportSelection.selectedEmployees.length === 1
                    ? t("CustomReport.Common.Employee")
                    : t("CustomReport.Common.Employees")
                }`
              : null}
            {` ${t("CustomReport.Common.Selected")}`}
          </div>
          <div className="col-lg-3 col-md-3">
            <button className="btn" onClick={editClicked}>
              {t("CustomReport.Common.Edit")}
            </button>
          </div>
        </div>
        {this.state.showModal ? (
          <LocationsEmployeeSelectionModal
            closePopup={closePopup}
            updateSelections={updateSelections}
            selectedEmployees={reportSelection.selectedEmployees}
            selectedLocations={reportSelection.selectedLocations}
          />
        ) : null}
      </Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    reportSelection: state.reportSelection,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setLocationsAndEmployees: (locations, employees) => {
      dispatch(reportSelectionActions.setLocationsAndEmployees(locations, employees))
    },
  }
}

export default compose(translate(), connect(mapStateToProps, mapDispatchToProps))(LocationSelection)



// WEBPACK FOOTER //
// ./src/components/custom-report/LocationSelection.jsx